import { AuditTrailEvent, AuditTrailEntity } from "../../misc/api/apiTypes";
import * as React from "react";
import LoadingWithMessage from "../../misc/components/LoadingWithMessage";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { AuditTrailActionEnum } from "../../misc/api/ApiAuditActions";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

interface HistoryViewCommentsDetailsProps {
    event: AuditTrailEvent;
}

const HistoryViewCommentsDetails = ({ event }: HistoryViewCommentsDetailsProps): JSX.Element => {

    const validActions = [AuditTrailActionEnum.ReopenAnalysisSet, AuditTrailActionEnum.UpdateCoughAnalysisSetReopenReason]

    const [loading, setLoading] = React.useState<boolean>();
    const [eventDetails, setEventDetails] = React.useState<AuditTrailEvent>();
    const [failedToLoad, setFailedToLoad] = React.useState<boolean>(false);
    const legacyClient = useWebPortalLegacyClient();

    const fetchEventDetails = async () => {
        try {
            setLoading(true);
            const eventDetails = await legacyClient.getAuditTrailEvent(event.Id);
            setEventDetails(eventDetails);
            setFailedToLoad(false);
        } catch {
            setFailedToLoad(true);
        } finally {
            setLoading(false);
        }
    }

    const renderButton = () => {
        return (<button className="btn btn-primary" onClick={fetchEventDetails}>Show Comment Details</button>);
    }

    const getChangedDetails = (entityChange: AuditTrailEntity) => {
        const changedComment = entityChange.Details.find(d => d.PropertyName === "Comment");

        return (changedComment ? <li key={entityChange.Id}><del>{changedComment.OriginalValue}</del> -&gt; <ins>{changedComment.NewValue}</ins></li> : null)
    }

    const renderEventDetails = () => {

        let changedComments: AuditTrailEntity[] = [];

        if (event.ActionId === AuditTrailActionEnum.ReopenAnalysisSet || event.ActionId === AuditTrailActionEnum.UpdateCoughAnalysisSetReopenReason) {
            changedComments = eventDetails.Entities.filter(e => e.TypeName === "CoughAnalysisSetReOpenComment");
        }

        return (!failedToLoad ? <ul>
            {changedComments.length ? changedComments.map(getChangedDetails) : <li>No Changes</li>}
        </ul> : <Alert show={true} category={AlertCategoryEnum.Danger}>
                An error occurred when loading the details.
                </Alert>);
    }

    const renderDetails = () => {
        return (loading ? <LoadingWithMessage message="Loading Event Details..." /> : renderEventDetails());
    }

    const renderBody = () => {
        return (<div className="row">
            <div className="col-md-12">
                {!!eventDetails || loading ? renderDetails() : renderButton()}
            </div>
        </div>);
    }

    return (validActions.find(a => a === event.ActionId) ? renderBody() : null);
}

export default HistoryViewCommentsDetails;
